@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

:host {
  display: $select-host-display;
}

@mixin status($selectColor, $selectBorderColor, $selectLabelColor, $statusText) {
  .select-element {
    color: $selectColor;
    border-color: $selectBorderColor;
  }

  .select-label {
    color: $selectLabelColor;
  }

  .status-text {
    color: $statusText;
  }
}

.select-wrapper {
  position: relative;
  width: $select-width;
  --air-dropdown-base-width: #{$select-width};
  --air-dropdown-base-min-width: #{$select-min-width};
  --air-dropdown-base-max-width: #{$select-max-width};
  --air-dropdown-base-border: #{$select-content-border-width} #{$select-content-border-style} #{$select-content-border-color};
  --air-dropdown-base-border-radius: #{$select-border-radius};
  --air-dropdown-base-padding-top: #{$select-content-padding-top};
  --air-dropdown-base-padding-right: #{$select-content-padding-right};
  --air-dropdown-base-padding-bottom: #{$select-content-padding-bottom};
  --air-dropdown-base-padding-left: #{$select-content-padding-left};
  --air-dropdown-base-margin-top: #{$select-content-margin-top};
  --air-dropdown-base-margin-right: #{$select-content-margin-right};
  --air-dropdown-base-margin-bottom: #{$select-content-margin-bottom};
  --air-dropdown-base-margin-left: #{$select-content-margin-left};
  --air-dropdown-base-max-height: #{$select-content-max-height};

  &.error {
    @include status(
      $select-error-color,
      $select-error-border-color,
      $select-error-label-color,
      $select-error-label-color
    );
  }

  &.success {
    @include status(
      $select-success-color,
      $select-success-border-color,
      $select-success-label-color,
      $select-success-label-color
    );
  }

  &:not(.with-status) {
    &.opened,
    &:hover {
      .select-element:not(.disabled):not(.readonly) {
        color: $select-hover-color;
        border-color: $select-hover-border-color;
        background-color: $select-hover-background-color;
      }
    }
  }

  .required-mark {
    color: $select-mark-required-color;
  }

  .select-label {
    display: block;
    font-family: $select-font-family;
    margin-top: $select-label-margin-top;
    margin-right: $select-label-margin-right;
    margin-bottom: $select-label-margin-bottom;
    margin-left: $select-label-margin-left;
  }

  .status-text {
    display: block;
    font-family: $select-font-family;
    margin-top: $select-status-text-margin-top;
    margin-right: $select-status-text-margin-right;
    margin-bottom: $select-status-text-margin-bottom;
    margin-left: $select-status-text-margin-left;
  }
}

.opened {
  .indicator {
    transform: rotate(180deg);
  }
}

.select-element-wrapper {
  position: relative;
}

.select-element {
  display: $select-display;
  width: $select-width;
  min-width: $select-min-width;
  max-width: $select-max-width;
  margin-top: $select-margin-top;
  margin-left: $select-margin-left;
  margin-bottom: $select-margin-bottom;
  margin-right: $select-margin-right;
  padding-top: $select-padding-top;
  padding-left: $select-padding-left;
  padding-bottom: $select-padding-bottom;
  padding-right: $select-padding-right;
  border-radius: $select-border-radius;
  border: $select-border-width $select-border-style $select-border-color;
  outline: none;
  background-color: $select-background-color;

  &:focus:not(.disabled),
  &:focus-within:not(.disabled) {
    box-shadow: 0 0 0 $select-focus-outline-width $select-focus-outline-color;
  }

  &.disabled {
    background-color: $select-disabled-background-color;
    color: $select-disabled-color;
    border-color: $select-disabled-border-color;

    .chevron {
      color: $select-disabled-color;
    }
  }

  input {
    color: $select-color;
    font-family: $select-font-family;
    font-size: $select-font-size;
    font-weight: $select-font-weight;
  }

  &.readonly {
    background-color: $select-readonly-background-color;
    color: $select-readonly-color;
    border-color: $select-readonly-border-color;

    .chevron {
      color: $select-readonly-color;
    }
  }
}

.trigger {
  cursor: pointer;
  position: relative;
}

.trigger-wrapper {
  display: flex;
}

air-select-option {
  width: 100%;
}

.selected-name {
  width: 100%;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: none;
  padding: 0;
  background-color: transparent;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: $select-placeholder-color;
  }
}

.no-results {
  color: $select-no-results-color;
  font-size: $select-no-results-font-size;
  font-family: $select-no-results-font-family;
  font-weight: $select-no-results-font-weight;
  line-height: $select-no-results-line-height;
  text-align: $select-no-results-text-align;
}

.footer-button {
  width: $select-footer-width;
  color: $select-footer-button-color;
  font-size: $select-footer-button-font-size;
  font-family: $select-footer-button-font-family;
  font-weight: $select-footer-button-font-weight;
  line-height: $select-footer-button-line-height;
  margin-top: $select-footer-button-margin-top;
  margin-right: $select-footer-button-margin-right;
  margin-bottom: $select-footer-button-margin-bottom;
  margin-left: $select-footer-button-margin-left;
  padding-top: $select-footer-button-padding-top;
  padding-right: $select-footer-button-padding-right;
  padding-bottom: $select-footer-button-padding-bottom;
  padding-left: $select-footer-button-padding-left;
  cursor: pointer;
  border-top: $select-footer-button-border-top;
  border-right: $select-footer-button-border-right;
  border-bottom: $select-footer-button-border-bottom;
  border-left: $select-footer-button-border-left;
  background-color: $select-footer-button-background-color;
  &:hover {
    background-color: $select-footer-button-hover-background-color;
  }
  &:focus {
    outline: none;
  }
}

@media (max-width: $breakpoint-mobile) {
  :host {
    width: #{$mobile-select-width};
  }

  .select-wrapper {
    --air-select-width: #{$mobile-select-width};
  }
}
